// extracted by mini-css-extract-plugin
export default {"buyButton":"tgHVw","sizeBig":"NO93b","hasInCart":"loukm","iconCheck":"Qs7nc"};